import DeliveryMethodDetail from './VoucherDetail';

export default DeliveryMethodDetail;



// WEBPACK FOOTER //
// ./src/scenes/Vouchers/VoucherDetail/index.ts